"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ const defaultTranslations = exports.defaultTranslations = {
    downloadPdf: 'Download PDF',
    networkError: 'Network error',
    successfullySent: 'Successfully sent!',
    summary: 'Summary',
    yourConcernWasSuccessfullySent: 'Your concern was successfully sent.\nSee your filled report below, you can also download it as a PDF.'
};
const translationsNamespace = exports.translationsNamespace = 'user-support_report-a-concern';
